import React from "react";
import "../HomeIndustries.css";

import {
    FiShoppingBag,
    FiTruck,
    FiBookOpen,
    FiActivity,
    FiSettings,
    FiBox,
    FiArrowRight,
} from "react-icons/fi";

const industries = [
    {
        icon: <FiShoppingBag />,
        title: "Retail & E-Commerce",
        description:
            "Build scalable online stores, marketplaces, POS integrations, and customer-centric shopping experiences.",
    },
    {
        icon: <FiBox />,
        title: "Agriculture",
        description:
            "Digital marketplaces, farmer management, inventory solutions, and agri-commerce platforms.",
    },
    {
        icon: <FiSettings />,
        title: "Manufacturing",
        description:
            "ERP solutions, inventory tracking, production workflows, and supply chain automation.",
    },
    {
        icon: <FiActivity />,
        title: "Healthcare",
        description:
            "Secure digital platforms for clinics, hospitals, appointments, and healthcare management.",
    },
    {
        icon: <FiBookOpen />,
        title: "Education",
        description:
            "Learning management systems, student portals, online courses, and digital education platforms.",
    },
    {
        icon: <FiTruck />,
        title: "Logistics & Distribution",
        description:
            "Fleet management, warehouse solutions, shipment tracking, and delivery optimization.",
    },
];

const HomeIndustries = () => {
    return (
        <section className="home-industries">

            <div className="container">

                <div className="industries-heading">

                    <span className="industries-badge">
                        Featured Industries
                    </span>

                    <h2>
                        Industries We <span>Empower</span>
                    </h2>

                    <p>
                        Kishancart Digital develops innovative digital solutions
                        for businesses across diverse industries, helping them
                        improve efficiency, accelerate growth, and embrace
                        digital transformation.
                    </p>

                </div>

                <div className="industries-grid">

                    {industries.map((item, index) => (

                        <div
                            className="industry-card"
                            key={index}
                        >

                            <div className="industry-icon">
                                {item.icon}
                            </div>

                            <h3>{item.title}</h3>

                            <p>{item.description}</p>

                            {/* <div className="industry-link">
                                Read More
                                <FiArrowRight />
                            </div> */}

                        </div>

                    ))}

                </div>

                

            </div>

        </section>
    );
};

export default HomeIndustries;